/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-19 16:53:03
 * @LastEditTime: 2020-12-17 11:32:12
 * @FilePath: \ensurance-front\src\router\modules\enrollmentRegistration.js
 */
const EnrollmentRegistration = () => import('@/views/enrollment-registration/enrollment-registration.vue')
const EnterInfo = () => import('@/views/enrollment-registration/enter-info/enter-info.vue')
const EnterInfoBatch = () => import('@/views/enrollment-registration/enter-info-batch/enter-info-batch.vue')
const EnterInfoBatchUpload = () => import('@/views/enrollment-registration/enter-info-batch-upload/enter-info-batch-upload.vue')
const BeforeInfoReview = () => import('@/views/enrollment-registration/before-info-review/before-info-review.vue')
const detailInfo = () => import('@/views/enrollment-registration/detail-info/detail-info.vue')

export default [
  {
    path: '/enrollmentRegistration',
    name: 'EnrollmentRegistration',
    component: EnrollmentRegistration,
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: '/enrollmentRegistration/enter_info',
        name: 'EnterInfo',
        component: EnterInfo,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/enrollmentRegistration/enter_info_batch',
        name: 'EnterInfoBatch',
        component: EnterInfoBatch,
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/enrollmentRegistration/enter_info_batch_upload',
        name: 'EnterInfoBatchUpload',
        component: EnterInfoBatchUpload,
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/enrollmentRegistration/review_info',
        name: 'BeforeInfoReview',
        component: BeforeInfoReview,
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/enrollmentRegistration/detail_info',
        name: 'BeforeInfoReview',
        component: detailInfo,
        meta: {
          keepAlive: false
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/enrollmentRegistration.js